import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { components } from 'react-select';

import Select from '../../components/BaseSelect';
import getCountriesList from '../../lib/countries';
import { selectTransferType } from '../transferTypes/transferTypesSlice';
import { resetToStep } from '../step/stepSlice';
import { setReceiverCountryCode } from './receiverSlice';

const CustomOption = ({ selectProps, isSelected, innerProps, data, children }) => {
  let className = `${selectProps.classNamePrefix}__option`;

  if (isSelected) {
    className += ' react-select__option--is-selected';
  }

  return (
    <div className={className} {...innerProps}>
      {children}
    </div>
  );
};

const Input = (props) => <components.Input {...props} inputMode="tel" />;

export default function CountrySelect() {
  const { countryCode } = useSelector((state) => state.receiver);
  const { allSupportedCountries } = useSelector((state) => state.transferTypes);
  const dispatch = useDispatch();

  useEffect(() => {
    const search = window.location.search;
    if (search) {
      const searchIsValid = search.includes('country=');
      if (searchIsValid) {
        const countryCodeFromSearch = search.split('country=')[1];

        if (countryCodeFromSearch) {
          dispatch(setReceiverCountryCode(countryCodeFromSearch));
        }
      }
    }
  }, [dispatch]);

  const countries = getCountriesList(allSupportedCountries);

  const handleCountryChange = (o) => {
    dispatch(setReceiverCountryCode(o.code));

    dispatch(selectTransferType(1)); //reset to "Top up"
    dispatch(resetToStep(1)); //reset form to ReceiverPhoneNumber
  };

  return (
    <div className="form-group emoji">
      <Select
        value={countries.find((c) => c.code === countryCode)}
        onChange={handleCountryChange}
        className="country-select"
        options={countries}
        components={{ Option: CustomOption, Input }}
      />
    </div>
  );
}
